<div class="agpr-briefingReviewStep">
    @if (briefing) {
        @if (briefingsService.isBlockLimitExceeded) {
            <agpr-message class="agpr-briefingReviewStep-blockLimitBanner" [severity]="messageSeverityEnum.warning">
                {{ 'Briefing.totalBlocks.limitExceeded.tooltip' | localize:{number: briefingsService.totalBlockCount} }}
            </agpr-message>
        }
        <!-- Canvas -->
        @if(briefing?.deliveryMethod === deliveryMethods.ONLINE) {
            <div
                class="agpr-briefingReviewStep-sectionContainer"
                id="canvas_sectionContainer"
            >
                <h4
                    class="agpr-briefingReviewStep-sectionLabel"
                    id="canvas_sectionLabel"
                >
                    {{ 'Briefing.reviewStep.canvas' | localize}}
                </h4>
                @if (subjectError) {
                    <div
                        class="agpr-briefingReviewStep-row"
                        id="canvas_error_row"
                    >
                        <span class="agpr-briefingReviewStep-icon fa-solid fa-circle-minus" aria-hidden="true"></span>
                        <agpr-button
                            class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                            [id]="'canvasError_sectionLabel'"
                            [style]="buttonTypes.link"
                            (click)="focusErrorElement(subjectError)"
                        >
                            <span>  {{ 'Briefing.reviewStep.canvas.nameRequired' | localize }} </span>
                        </agpr-button>
                    </div>
                } @else {
                    <div
                        class="agpr-briefingReviewStep-row"
                        id="canvas_noError_row"
                    >
                        <span class="agpr-briefingReviewStep-icon fa-solid fa-circle-check" aria-hidden="true"></span>
                        <label>
                            {{ 'Briefing.reviewStep.composition.noErrors' | localize }}
                        </label>
                    </div>
                }

                <div
                    class="agpr-briefingReviewStep-editButtonContainer"
                    id="canvas_editButtonContainer"
                >
                    <agpr-button
                        class="agpr-briefingReviewStep-editButton"
                        [id]="'editCanvas'"
                        label="Briefing.reviewStep.canvas.editButton"
                        [style]="buttonTypes.tertiary"
                        (click)="navigateToPublishingStep()"
                    ></agpr-button>
                </div>
            </div>
        }
        <!-- composition -->
        <div
            class="agpr-briefingReviewStep-sectionContainer"
            id="composition_sectionContainer"
        >
            <h4
                class="agpr-briefingReviewStep-sectionLabel"
                id="composition_sectionLabel"
            >
                {{ 'Briefing.reviewStep.composition' | localize}}
            </h4>
            <div
                class="agpr-briefingReviewStep-composition"
                id="composition_details"
            >
                <ng-container *ngIf="compositionErrors?.length === 0">
                    <div
                        class="agpr-briefingReviewStep-composition-row"
                        id="composition_noError_row"
                    >
                        <span class="agpr-briefingReviewStep-icon fa-solid fa-circle-check" aria-hidden="true"></span>
                        <label>
                            {{ 'Briefing.reviewStep.composition.noErrors' | localize }}
                        </label>
                    </div>
                </ng-container>
                <ng-container *ngIf="compositionErrors?.length > 0">
                    <div
                        class="agpr-briefingReviewStep-composition-row"
                        id="composition_error_row"
                    >
                        <span class="agpr-briefingReviewStep-icon fa-solid fa-circle-minus" aria-hidden="true"></span>
                        <label
                            class="agpr-briefingReviewStep-composition-errorText"
                            id="compositionError_sectionLabel"
                        >
                            {{ 'Briefing.reviewStep.composition.errorMessage' | localize }}
                        </label>
                    </div>
                    <ul
                        class="agpr-briefingReviewStep-composition-errorList"
                        id="composition_error_lst"
                        aria-labelledby="compositionError_sectionLabel"
                        tabindex="-1"
                        agprListKeyboardNavigation
                        listOrientation="horizontal"
                        [focusOnChild]="true"
                        [list]="compositionErrors"
                    >
                        <li *ngFor="let error of compositionErrors">
                            <agpr-button
                                [style]="buttonTypes.link"
                                (click)="focusErrorElement(error)"
                                [attr.aria-label]="error.label | localize"
                            >
                                <span> {{ error.label | localize }} </span>
                            </agpr-button>
                        </li>
                    </ul>
                </ng-container>
                <div
                    class="agpr-briefingReviewStep-mentionCount"
                    id="composition_mentionCount"
                >
                    <agpr-message
                        *ngIf="allocatedMentionsCount > 0 && allocatedMentionsCount / maxNumberOfMentionsInBriefing < 0.75"
                        [severity]="messageSeverityEnum.info"
                    >
                        <span class="agpr-briefingReviewStep-mentionCount-highlight">{{ allocatedMentionsCount + '/' + maxNumberOfMentionsInBriefing}}</span>
                        <span>{{ 'Briefings.addCoverage.mentionsAdded' | localize }}</span>
                    </agpr-message>
                    <agpr-message
                        *ngIf="allocatedMentionsCount / maxNumberOfMentionsInBriefing > 0.75 && allocatedMentionsCount <= maxNumberOfMentionsInBriefing"
                        [severity]="messageSeverityEnum.warning"
                    >
                        <span class="agpr-briefingReviewStep-mentionCount-highlight">{{ allocatedMentionsCount + '/' + maxNumberOfMentionsInBriefing}}</span>
                        <span>{{ 'Briefings.addCoverage.mentionsAdded' | localize }}</span>
                    </agpr-message>
                    <agpr-message
                        *ngIf="allocatedMentionsCount > maxNumberOfMentionsInBriefing"
                        [severity]="messageSeverityEnum.error"
                    >
                        <span class="agpr-briefingReviewStep-mentionCount-highlight">{{ allocatedMentionsCount + '/' + maxNumberOfMentionsInBriefing}}</span>
                        <span>{{ 'Briefings.addCoverage.mentionsAdded' | localize }}</span>
                    </agpr-message>
                    @if (numAutoGenMentions > 100) {
                        <agpr-message
                            [severity]="messageSeverityEnum.warning"
                            [agprTooltip]="'Briefings.blockType.autoGeninsights.limitFeedback.tooltip'"
                        >
                            {{ 'Briefings.blockType.autoGeninsights.limitFeedback' | localize }}
                        </agpr-message>
                    }
                </div>
            </div>
            <div
                class="agpr-briefingReviewStep-editButtonContainer"
                id="composition_editButtonContainer"
            >
                <agpr-button
                    class="agpr-briefingReviewStep-editButton"
                    [id]="'editComposition'"
                    label="Briefing.reviewStep.editComposition"
                    [style]="buttonTypes.tertiary"
                    (click)="navigateToComposeStep()"
                ></agpr-button>
            </div>
        </div>

        <div
            class="agpr-briefingReviewStep-sectionContainer"
            id="scheduling_sectionContainer"
        >
            <h4
                class="agpr-briefingReviewStep-sectionLabel"
                id="scheduling_sectionLabel"
            >
                {{ 'Briefing.reviewStep.scheduling' | localize}}
            </h4>


            @if (schedulingError.label) {
                <div
                    class="agpr-briefingReviewStep-row"
                    id="scheduling_error_row"
                >
                    <span class="agpr-briefingReviewStep-icon fa-solid fa-circle-minus" aria-hidden="true"></span>
                    <label
                        class="agpr-briefingReviewStep-errorText"
                        id="schedulingError_sectionLabel"
                    >
                        {{ schedulingError.label | localize }}
                    </label>
                </div>
            } @else {
                <div
                    class="agpr-briefingReviewStep-row"
                    id="scheduling_noError_row"
                >
                    <span class="agpr-briefingReviewStep-icon fa-solid fa-circle-check" aria-hidden="true"></span>
                    <label>
                        @if (briefing.sendAt.sendNow) {
                            {{ 'Briefings.input.publishNow' | localize }}
                        } @else if (briefing.sendAt.sendLater) {
                            {{ 'Briefings.input.publishLater' | localize }}
                        } @else {
                            {{ 'Briefings.input.publishRecurring' | localize }}
                        }
                    </label>
                </div>
            }

            <div
                class="agpr-briefingReviewStep-editButtonContainer"
                id="scheduling_editButtonContainer"
            >
                <agpr-button
                    class="agpr-briefingReviewStep-editButton"
                    [id]="'editScheduling'"
                    label="Briefing.reviewStep.scheduling.editButton"
                    [style]="buttonTypes.tertiary"
                    (click)="navigateToPublishingStep()"
                ></agpr-button>
            </div>
        </div>


        @if(briefing?.deliveryMethod === deliveryMethods.EMAIL) {
            <div
                class="agpr-briefingReviewStep-sectionContainer"
                id="details_sectionContainer"
            >
                <h4
                    class="agpr-briefingReviewStep-sectionLabel"
                    id="details_sectionLabel"
                >
                    {{ 'Briefing.reviewStep.details' | localize}}
                </h4>

                @if (briefing?.selectedDeliveryOption.email) {
                    <div
                        class="agpr-briefingReviewStep-publishing"
                        id="details_email_publishing"
                    >
                        <h5>{{ 'Briefing.reviewStep.details.email' | localize }}</h5>
                        <div
                            class="agpr-briefingReviewStep-publishing-details"
                            id="details_email_publishing-details"
                        >
                            <div
                                class="agpr-briefingReviewStep-publishing-details-row"
                                id="details_subject_row"
                            >
                                <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                    <span
                                        class="agpr-briefingReviewStep-icon fa-solid"
                                        [ngClass]="{
                                            'fa-circle-minus': !!subjectError,
                                            'fa-circle-check': !subjectError
                                        }"
                                        aria-describedby="subject_missing_error"
                                    ></span>
                                </div>
                                <label class="agpr-briefingReviewStep-publishing-details-row-label">
                                    {{ 'Briefings.input.subjectLine' | localize }}
                                </label>
                                <label *ngIf="briefing?.subject && !!briefing.subject.trim()" class="agpr-briefingReviewStep-publishing-details-row-label-updatedText">
                                    {{ briefing.subject }}
                                </label>
                                <agpr-button
                                    *ngIf="subjectError"
                                    class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                    [id]="'subject_missing_error'"
                                    [style]="buttonTypes.link"
                                    (click)="focusErrorElement(subjectError)"
                                >
                                    <span>  {{ 'Briefings.input.subjectLine.validation' | localize }} </span>
                                </agpr-button>
                            </div>

                            <div
                                class="agpr-briefingReviewStep-publishing-details-row"
                                id="details_fromName_row"
                            >
                                <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                    <span
                                        class="agpr-briefingReviewStep-icon fa-solid"
                                        [ngClass]="{
                                            'fa-circle-minus': !!fromNameError,
                                            'fa-circle-check': !fromNameError
                                        }"
                                        aria-describedby="fromName_missing_error"
                                    ></span>
                                </div>
                                <label class="agpr-briefingReviewStep-publishing-details-row-label">
                                    {{ 'Briefings.input.fromName' | localize }}
                                </label>
                                <label *ngIf="briefing?.fromName && !!briefing?.fromName.trim()" class="agpr-briefingReviewStep-publishing-details-row-label-updatedText">
                                    {{ briefing.fromName }}
                                </label>
                                <agpr-button
                                    *ngIf="fromNameError"
                                    class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                    [id]="'fromName_missing_error'"
                                    [style]="buttonTypes.link"
                                    (click)="focusErrorElement(fromNameError)"
                                >
                                    <span>  {{ 'Briefings.input.fromName.validation' | localize }} </span>
                                </agpr-button>

                            </div>

                            <div
                                class="agpr-briefingReviewStep-publishing-details-row"
                                id="details_replyTo_row"
                            >
                                <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                    <span
                                        class="agpr-briefingReviewStep-icon fa-solid"
                                        [ngClass]="{
                                            'fa-circle-minus': !!replyToError,
                                            'fa-circle-check': !replyToError
                                        }"
                                        aria-describedby="replyTo_missing_error"
                                    ></span>
                                </div>
                                <label class="agpr-briefingReviewStep-publishing-details-row-label">
                                    {{ 'Briefings.input.replyTo' | localize }}
                                </label>
                                <label *ngIf="briefing?.replyTo && !!briefing.replyTo.trim()" class="agpr-briefingReviewStep-publishing-details-row-label-updatedText">
                                    {{ briefing.replyTo }}
                                </label>
                                <agpr-button
                                    *ngIf="replyToError"
                                    class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                    [id]="'replyTo_missing_error'"
                                    [style]="buttonTypes.link"
                                    (click)="focusErrorElement(replyToError)"
                                >
                                    <span>  {{ 'Briefings.input.replyTo.validation' | localize }} </span>
                                </agpr-button>
                            </div>

                            <div
                                class="agpr-briefingReviewStep-publishing-details-row"
                                id="details_reservedUrl_row"
                            >
                                <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                    <span
                                        class="agpr-briefingReviewStep-icon fa-solid"
                                        [ngClass]="{
                                            'fa-circle-ellipsis': !reservedUrl && !briefing.sendAt.recurring,
                                            'fa-circle-xmark': briefing.sendAt.recurring,
                                            'fa-circle-check': reservedUrl && !briefing.sendAt.recurring
                                        }"
                                    ></span>
                                </div>
                                <label class="agpr-briefingReviewStep-publishing-details-row-label">
                                    {{ 'Briefings.sidebar.headingReservedURL' | localize }}
                                </label>
                            </div>
                            <div
                                *ngIf="reservedUrl && !briefing.sendAt.recurring"
                                class="agpr-briefingReviewStep-publishing-details-reservedUrl"
                                id="details_reservedUrl"
                            >
                                @if (draftPublished) {
                                    <a
                                        [href]="reservedUrl"
                                        class="agpr-briefingReviewStep-publishing-details-reservedUrl-link"
                                        target="_blank"
                                    >
                                        {{ reservedUrl }}
                                    </a>
                                } @else {
                                    <span class="agpr-briefingReviewStep-publishing-details-reservedUrl-link">
                                        {{ reservedUrl }}
                                    </span>
                                }

                                <agpr-button
                                    class="agpr-briefingReviewStep-reservedUrl-urlCopyIcon"
                                    [style]="buttonTypes.icon"
                                    icon="fa-kit-duotone fa-agpr-copy"
                                    tooltip="Reports.sharedReports.rhp.copyUrl"
                                    tooltipPosition="top"
                                    (click)="copyUrl($event, reservedUrl)"
                                ></agpr-button>
                            </div>
                            @if (!reservedUrl && !briefing.sendAt.recurring) {
                                <label
                                    class="agpr-briefingReviewStep-publishing-details-row-label-updatedText"
                                    id="details_reservedUrl_noUrl"
                                >
                                    <span>
                                        {{ 'Briefings.reservedUrl.noUrlAvailable' | localize }}
                                    </span>
                                </label>
                            }

                            @if (briefing.sendAt.recurring) {
                                <label
                                    class="agpr-briefingReviewStep-publishing-details-row-label-updatedText"
                                    id="details_reservedUrl_noRecurring"
                                >
                                    <span>
                                        {{ 'Briefings.reservedUrl.noRecurringUrl' | localize }}
                                    </span>
                                </label>
                            }

                            @if (reservedUrl && !briefing.sendAt.recurring) {
                                <agpr-button
                                    class="agpr-briefingReviewStep-editButton"
                                    [id]="'publishDraft'"
                                    [loading]="publishDraftInProgress"
                                    [label]="draftPublished ? 'Briefings.reservedUrl.updateDraft' : 'Briefings.reservedUrl.createDraft'"
                                    [style]="buttonTypes.tertiary"
                                    (click)="publishDraft.emit()"
                                ></agpr-button>
                            }


                            <div
                                class="agpr-briefingReviewStep-publishing-recipients"
                                id="details_recipients"
                            >
                                <span
                                    class="agpr-briefingReviewStep-icon fa-solid"
                                    [ngClass]="{
                                        'fa-circle-minus': !!mailingListError || !!recipientError,
                                        'fa-circle-check': !mailingListError && !recipientError
                                    }"
                                ></span>

                                @if (!mailingListError && !recipientError) {
                                    <label>
                                        {{ 'Briefing.reviewStep.details.recipients' | localize }}
                                    </label>
                                } @else if (mailingListError) {
                                    <agpr-button
                                        class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                        [style]="buttonTypes.link"
                                        (click)="focusErrorElement(mailingListError)"
                                    >
                                        <span>  {{ 'Briefings.input.mailingLists.validation' | localize }} </span>
                                    </agpr-button>
                                } @else if (recipientError) {
                                    <agpr-button
                                        class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                        [style]="buttonTypes.link"
                                        (click)="focusErrorElement(recipientError)"
                                    >
                                        <span>  {{ 'Briefing.reviewStep.details.recipients.error' | localize }} </span>
                                    </agpr-button>
                                }
                            </div>
                            <div
                                class="agpr-briefingReviewStep-publishing-recipients-details"
                                id="details_recipients_details"
                            >
                                <div
                                    class="agpr-briefingReviewStep-publishing-recipients-details-section"
                                    id="details_mailingLists_section"
                                >
                                    <span class="agpr-briefingReviewStep-publishing-recipients-details-section-name">{{ 'Briefing.reviewStep.details.recipients.mailingLists' | localize }}</span>
                                    <span>{{ totalMailingListRecipients }}</span>
                                </div>
                                <ul>
                                    @for (list of mailingLists; track list.id) {
                                        <li class="agpr-briefingReviewStep-publishing-recipients-details-row">
                                            <span class="agpr-briefingReviewStep-publishing-recipients-details-row-name">{{ list.name }}</span>
                                            <span>{{ list.count }}</span>
                                        </li>
                                    }
                                </ul>
                                <div
                                    class="agpr-briefingReviewStep-publishing-recipients-details-section"
                                    id="details_additional_section"
                                >
                                    <span class="agpr-briefingReviewStep-publishing-recipients-details-section-name">{{ 'Briefing.reviewStep.details.recipients.additional' | localize }}</span>
                                    <span>{{ briefing?.recipientList?.length || 0  }}</span>
                                </div>
                                <ul>
                                    @for (recipient of briefing?.recipientList; track recipient) {
                                        <li class="agpr-briefingReviewStep-publishing-recipients-details-row">
                                            <span>{{ recipient }}</span>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                }
                @if (briefing?.selectedDeliveryOption?.rssFeed) {
                    @if (briefing?.selectedDeliveryOption.email) {
                        <div class="agpr-briefingReviewStep-publishing-divider"></div>
                    }
                    <div
                        class="agpr-briefingReviewStep-publishing"
                        id="details_rss_publishing"
                    >
                        <h5>{{ 'Briefing.reviewStep.details.rss' | localize }}</h5>
                        <div
                            class="agpr-briefingReviewStep-publishing-details"
                            id="details_rss_publishing-details"
                        >
                            @for (feed of briefing.feeds; track feed.id) {
                                <div class="agpr-briefingReviewStep-publishing-recipients">
                                    <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                        <span
                                            class="agpr-briefingReviewStep-icon fa-solid fa-circle-check"
                                        ></span>
                                    </div>
                                    <a
                                        class="agpr-briefingReviewStep-rssFeed"
                                        [href]="feed.url"
                                        target="_blank"
                                    >
                                        {{ feed.url }}
                                    </a>
                                </div>
                            }
                            @if (rssFeedError) {
                                <div class="agpr-briefingReviewStep-publishing-recipients">
                                    <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                        <span
                                            class="agpr-briefingReviewStep-icon fa-solid fa-circle-minus"
                                        ></span>
                                    </div>
                                    <agpr-button
                                        class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                        [style]="buttonTypes.link"
                                        (click)="focusErrorElement(rssFeedError)"
                                    >
                                        <span>  {{ 'Briefing.reviewStep.details.noFeeds' | localize }} </span>
                                    </agpr-button>
                                </div>
                            }
                        </div>
                    </div>
                }

                @if (deliveryOptionsError) {
                    <div
                        class="agpr-briefingReviewStep-publishing"
                        id="details_deliveryOptionsError_publishing"
                    >
                        <h5>{{ deliveryOptionsError.label | localize }}</h5>
                        <div class="agpr-briefingReviewStep-publishing-details">
                            <div class="agpr-briefingReviewStep-publishing-recipients">
                                <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                    <span
                                        class="agpr-briefingReviewStep-icon fa-solid fa-circle-minus"
                                    ></span>
                                </div>
                                <agpr-button
                                    class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                    [style]="buttonTypes.link"
                                    (click)="focusErrorElement(deliveryOptionsError)"
                                >
                                    <span>  {{ 'Briefings.deliveryOptions.validation' | localize }} </span>
                                </agpr-button>
                            </div>
                        </div>
                    </div>
                }

                <div class="agpr-briefingReviewStep-publishing-divider"></div>
                <div
                    class="agpr-briefingReviewStep-editButtonContainer"
                    id="details_editButtonContainer"
                >
                    <agpr-button
                        class="agpr-briefingReviewStep-editButton"
                        [id]="'editDetails'"
                        label="Briefing.reviewStep.details.editButton"
                        [style]="buttonTypes.tertiary"
                        (click)="navigateToPublishingStep()"
                    ></agpr-button>
                </div>
            </div>
        }

        @if(briefing?.deliveryMethod === deliveryMethods.ONLINE) {
            <div
                class="agpr-briefingReviewStep-sectionContainer"
                id="publish_sectionContainer"
            >
                <h4
                    class="agpr-briefingReviewStep-sectionLabel"
                    id="publish_sectionLabel"
                >
                    {{ 'Briefing.reviewStep.publish' | localize}}
                </h4>

                <div
                    class="agpr-briefingReviewStep-publishing-details-row"
                    id="publish_reservedUrl_row"
                >
                    <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                        <span
                            class="agpr-briefingReviewStep-icon fa-solid"
                            [ngClass]="{
                                'fa-circle-ellipsis': !reservedUrl && !briefing.sendAt.recurring,
                                'fa-circle-xmark': briefing.sendAt.recurring,
                                'fa-circle-check': reservedUrl && !briefing.sendAt.recurring
                            }"
                        ></span>
                    </div>
                    <label class="agpr-briefingReviewStep-publishing-details-row-label">
                        {{ 'Briefings.sidebar.headingReservedURL' | localize }}
                    </label>
                </div>

                <div
                    *ngIf="reservedUrl && !briefing.sendAt.recurring"
                    class="agpr-briefingReviewStep-publishing-details-reservedUrl"
                    id="publish_reservedUrl"
                >
                    @if (draftPublished) {
                        <a
                            [href]="reservedUrl"
                            class="agpr-briefingReviewStep-publishing-details-reservedUrl-link"
                            target="_blank"
                        >
                            {{ reservedUrl }}
                        </a>
                    } @else {
                        <span class="agpr-briefingReviewStep-publishing-details-reservedUrl-link">
                            {{ reservedUrl }}
                        </span>
                    }

                    <agpr-button
                        class="agpr-briefingReviewStep-reservedUrl-urlCopyIcon"
                        [style]="buttonTypes.icon"
                        icon="fa-kit-duotone fa-agpr-copy"
                        tooltip="Reports.sharedReports.rhp.copyUrl"
                        tooltipPosition="top"
                        (click)="copyUrl($event, reservedUrl)"
                    ></agpr-button>
                </div>
                @if (!reservedUrl && !briefing.sendAt.recurring) {
                    <label
                        class="agpr-briefingReviewStep-publishing-details-row-label-updatedText"
                        id="publish_reservedUrl_noUrl"
                    >
                        <span>
                            {{ 'Briefings.reservedUrl.noUrlAvailable' | localize }}
                        </span>
                    </label>
                }

                @if (briefing.sendAt.recurring) {
                    <label
                        class="agpr-briefingReviewStep-publishing-details-row-label-updatedText"
                        id="publish_reservedUrl_noRecurring"
                    >
                        <span>
                            {{ 'Briefings.reservedUrl.noRecurringUrl' | localize }}
                        </span>
                    </label>
                }

                @if (briefing?.selectedDeliveryOption?.rssFeed) {
                    <div
                        class="agpr-briefingReviewStep-publishing"
                        id="publish_rss_publishing"
                    >
                        <h5>{{ 'Briefing.reviewStep.details.rss' | localize }}</h5>
                        <div
                            class="agpr-briefingReviewStep-publishing-details"
                            id="publish_rss_publishing-details"
                        >
                            @for (feed of briefing.feeds; track feed.id) {
                                <div class="agpr-briefingReviewStep-publishing-recipients">
                                    <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                        <span
                                            class="agpr-briefingReviewStep-icon fa-solid fa-circle-check"
                                        ></span>
                                    </div>
                                    <a
                                        class="agpr-briefingReviewStep-rssFeed"
                                        [href]="feed.url"
                                        target="_blank"
                                    >
                                        {{ feed.url }}
                                    </a>
                                </div>
                            }
                            @if (rssFeedError) {
                                <div class="agpr-briefingReviewStep-publishing-recipients">
                                    <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                        <span
                                            class="agpr-briefingReviewStep-icon fa-solid fa-circle-minus"
                                        ></span>
                                    </div>
                                    <agpr-button
                                        class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                        [style]="buttonTypes.link"
                                        (click)="focusErrorElement(rssFeedError)"
                                    >
                                        <span>  {{ 'Briefing.reviewStep.details.noFeeds' | localize }} </span>
                                    </agpr-button>
                                </div>
                            }
                        </div>
                    </div>
                }

                @if (digestString) {
                    <h5 class="agpr-briefingReviewStep-publishing-details-margin">{{ 'Briefings.deliveryOptions.digest.online' | localize }}</h5>
                    <div
                        class="agpr-briefingReviewStep-publishing-details-row"
                        id="publish_digest_row"
                    >
                        <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                            <span
                                class="agpr-briefingReviewStep-icon fa-solid fa-circle-check"
                            ></span>
                        </div>
                        <label class="agpr-briefingReviewStep-publishing-details-row-label">
                            {{ 'Briefings.deliveryOptions.digest' | localize }}
                        </label>

                        <div class="agpr-briefingReviewStep-publishing-details-row-label-updatedText">
                            {{ digestString }}
                        </div>
                    </div>
                }

                <div
                    class="agpr-briefingReviewStep-editButtonContainer"
                    id="publish_editButtonContainer"
                >
                    <agpr-button
                        class="agpr-briefingReviewStep-editButton"
                        [id]="'editPublishing'"
                        label="Briefing.reviewStep.publish.editButton"
                        [style]="buttonTypes.tertiary"
                        (click)="navigateToPublishingStep()"
                    ></agpr-button>
                </div>
            </div>
        }

        @if(briefing?.deliveryMethod === deliveryMethods.ONLINE) {
            <div
                class="agpr-briefingReviewStep-sectionContainer"
                id="publishingNotifications_sectionContainer"
            >
                <h4
                    class="agpr-briefingReviewStep-sectionLabel"
                    id="publishingNotifications_sectionLabel"
                >
                    {{ 'Briefing.reviewStep.publishingNotifications' | localize}}
                </h4>

                @if (briefing?.selectedDeliveryOption.email) {
                    <div
                        class="agpr-briefingReviewStep-publishing"
                        id="publishingNotifications_email_publishing"
                    >
                        <h5>{{ 'Briefing.reviewStep.details.email' | localize }}</h5>
                        <div
                            class="agpr-briefingReviewStep-publishing-details"
                            id="publishingNotifications_email_publishing-details"
                        >
                            <div
                                class="agpr-briefingReviewStep-publishing-recipients"
                                id="publishingNotifications_recipients"
                            >
                                <!-- We don’t check recipientError for Canvas, so we check totalCount instead. -->
                                @let totalCount = (totalMailingListRecipients || 0) + (briefing?.recipientList?.length || 0);
                                <span
                                    class="agpr-briefingReviewStep-icon fa-solid"
                                    [ngClass]="{
                                        'fa-circle-minus': !!mailingListError,
                                        'fa-circle-check': !mailingListError && totalCount > 0
                                    }"
                                ></span>

                                @if (!mailingListError && totalCount > 0) {
                                    <label>
                                        {{ 'Briefing.reviewStep.details.recipients' | localize }}
                                    </label>
                                } @else if (mailingListError) {
                                    <agpr-button
                                        class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                        [style]="buttonTypes.link"
                                        (click)="focusErrorElement(mailingListError)"
                                    >
                                        <span>  {{ 'Briefings.input.mailingLists.validation' | localize }} </span>
                                    </agpr-button>
                                }
                            </div>
                            <div
                                class="agpr-briefingReviewStep-publishing-recipients-details"
                                id="publishingNotifications_recipients_details"
                            >
                                <div
                                    class="agpr-briefingReviewStep-publishing-recipients-details-section"
                                    id="publishingNotifications_mailingLists_section"
                                >
                                    <span class="agpr-briefingReviewStep-publishing-recipients-details-section-name">{{ 'Briefing.reviewStep.details.recipients.mailingLists' | localize }}</span>
                                    <span>{{ totalMailingListRecipients }}</span>
                                </div>
                                <ul>
                                    @for (list of mailingLists; track list.id) {
                                        <li class="agpr-briefingReviewStep-publishing-recipients-details-row">
                                            <span class="agpr-briefingReviewStep-publishing-recipients-details-row-name">{{ list.name }}</span>
                                            <span>{{ list.count }}</span>
                                        </li>
                                    }
                                </ul>
                                <div
                                    class="agpr-briefingReviewStep-publishing-recipients-details-section"
                                    id="publishingNotifications_additional_section"
                                >
                                    <span class="agpr-briefingReviewStep-publishing-recipients-details-section-name">{{ 'Briefing.reviewStep.details.recipients.additional' | localize }}</span>
                                    <span>{{ briefing?.recipientList?.length || 0  }}</span>
                                </div>
                                <ul>
                                    @for (recipient of briefing?.recipientList; track recipient) {
                                        <li class="agpr-briefingReviewStep-publishing-recipients-details-row">
                                            <span>{{ recipient }}</span>
                                        </li>
                                    }
                                </ul>
                            </div>

                            <div class="agpr-briefingReviewStep-publishing-divider"></div>

                            <div
                                class="agpr-briefingReviewStep-publishing-details-row"
                                id="publishingNotifications_fromName_row"
                            >
                                <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                    <span
                                        class="agpr-briefingReviewStep-icon fa-solid"
                                        [ngClass]="{
                                            'fa-circle-minus': !!fromNameError,
                                            'fa-circle-check': !fromNameError
                                        }"
                                        aria-describedby="publishingNotifications_fromName_missing_error"
                                    ></span>
                                </div>
                                <label class="agpr-briefingReviewStep-publishing-details-row-label">
                                    {{ 'Briefings.input.fromName' | localize }}
                                </label>
                                <label *ngIf="briefing?.fromName && !!briefing?.fromName.trim()" class="agpr-briefingReviewStep-publishing-details-row-label-updatedText">
                                    {{ briefing.fromName }}
                                </label>
                                <agpr-button
                                    *ngIf="fromNameError"
                                    class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                    [id]="'publishingNotifications_fromName_missing_error'"
                                    [style]="buttonTypes.link"
                                    (click)="focusErrorElement(fromNameError)"
                                >
                                    <span>  {{ 'Briefings.input.fromName.validation' | localize }} </span>
                                </agpr-button>

                            </div>

                            <div
                                class="agpr-briefingReviewStep-publishing-details-row"
                                id="publishingNotifications_replyTo_row"
                            >
                                <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                    <span
                                        class="agpr-briefingReviewStep-icon fa-solid"
                                        [ngClass]="{
                                            'fa-circle-minus': !!replyToError,
                                            'fa-circle-check': !replyToError
                                        }"
                                        aria-describedby="publishingNotifications_replyTo_missing_error"
                                    ></span>
                                </div>
                                <label class="agpr-briefingReviewStep-publishing-details-row-label">
                                    {{ 'Briefings.input.replyTo' | localize }}
                                </label>
                                <label *ngIf="briefing?.replyTo && !!briefing.replyTo.trim()" class="agpr-briefingReviewStep-publishing-details-row-label-updatedText">
                                    {{ briefing.replyTo }}
                                </label>
                                <agpr-button
                                    *ngIf="replyToError"
                                    class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                    [id]="'publishingNotifications_replyTo_missing_error'"
                                    [style]="buttonTypes.link"
                                    (click)="focusErrorElement(replyToError)"
                                >
                                    <span>  {{ 'Briefings.input.replyTo.validation' | localize }} </span>
                                </agpr-button>
                            </div>

                            <div
                                class="agpr-briefingReviewStep-publishing-details-row"
                                id="publishingNotifications_inviteMessage_row"
                            >
                                <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                    <span
                                        class="agpr-briefingReviewStep-icon fa-solid fa-circle-check"
                                    ></span>
                                </div>
                                <label class="agpr-briefingReviewStep-publishing-details-row-label">
                                    {{ 'Briefings.input.inviteMessage' | localize }}
                                </label>
                                <label *ngIf="briefing?.inviteMessage && !!briefing.inviteMessage.trim()" class="agpr-briefingReviewStep-publishing-details-row-label-updatedText">
                                    {{ briefing.inviteMessage }}
                                </label>
                            </div>
                        </div>
                    </div>
                }

                @if (deliveryOptionsError) {
                    <div
                        class="agpr-briefingReviewStep-publishing"
                        id="publishingNotifications_deliveryOptionsError_publishing"
                    >
                        <h5>{{ deliveryOptionsError.label | localize }}</h5>
                        <div class="agpr-briefingReviewStep-publishing-details">
                            <div class="agpr-briefingReviewStep-publishing-recipients">
                                <div class="agpr-briefingReviewStep-publishing-details-row-iconContainer">
                                    <span
                                        class="agpr-briefingReviewStep-icon fa-solid fa-circle-minus"
                                    ></span>
                                </div>
                                <agpr-button
                                    class="agpr-briefingReviewStep-publishing-details-row-label-requiredText"
                                    [style]="buttonTypes.link"
                                    (click)="focusErrorElement(deliveryOptionsError)"
                                >
                                    <span>  {{ 'Briefings.deliveryOptions.validation' | localize }} </span>
                                </agpr-button>
                            </div>
                        </div>
                    </div>
                }

                <div
                    class="agpr-briefingReviewStep-editButtonContainer"
                    id="publishingNotifications_editButtonContainer"
                >
                    <agpr-button
                        class="agpr-briefingReviewStep-editButton"
                        [id]="'editPublishingNotifications'"
                        label="Briefing.reviewStep.publishingNotifications.editButton"
                        [style]="buttonTypes.tertiary"
                        (click)="navigateToPublishingStep()"
                    ></agpr-button>
                </div>
            </div>
        }
    }
</div>
